import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // ✅ Correct Hook
import Layout from "../components/Layout";
import "../styles/JobDetails.css";
import API_BASE_URL from "../api";
const JobDetails = () => {
  const { id } = useParams(); // ✅ Correct way to fetch ID
  const [job, setJob] = useState(null);

  useEffect(() => {
    console.log("Job ID from URL:", id);

    if (!id) {
      console.error("Invalid job ID format");
      return;
    }

    fetch(`${API_BASE_URL}/api/jobdetails?id=${id}`)
      .then((res) => res.json())
      .then((data) => {
        console.log("Fetched job data:", data);
        if (data.error) {
          console.error("API Error:", data.error);
        } else {
          setJob(data);
        }
      })
      .catch((err) => console.error("Error fetching job details:", err));
  }, [id]);

  if (!job) {
    return (
     
        <p>Loading job details...</p>
      
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return isNaN(date) ? "N/A" : date.toLocaleDateString('en-IN'); // format like dd/mm/yyyy
  };

  return (
    
      <div className="job-details">
        <h2 style={{ color: "red", fontWeight: "bold", fontFamily: "serif" }}>
          {job.post_name}
        </h2>

        {/* About Post */}
        <table className="job-table">
          <thead>
            <tr><th colSpan="2"><strong>About Post</strong></th></tr>
          </thead>
          <tbody>
            <tr><td><strong>Post Name:</strong></td><td>{job.post_name || "N/A"}</td></tr>
            <tr><td><strong>Organization:</strong></td><td>{job.organization_name || "N/A"}</td></tr>
            <tr><td><strong>Category:</strong></td><td>{job.category || "N/A"}</td></tr>
            <tr><td><strong>Description:</strong></td><td>{job.description || "N/A"}</td></tr>
          </tbody>
        </table>

        {/* Important Dates */}
        <table className="job-table">
          <thead>
            <tr><th colSpan="2"><strong>Important Dates</strong></th></tr>
          </thead>
          <tbody>
            <tr><td><strong>Post Date:</strong></td><td>{formatDate(job.post_date)}</td></tr>
            <tr><td><strong>Qualification:</strong></td><td>{job.qualification || "N/A"}</td></tr>
            <tr><td><strong>As On Date:</strong></td><td>{formatDate(job.asondate)}</td></tr>
            <tr><td><strong>Last Date:</strong></td><td>{formatDate(job.last_date)}</td></tr>
            <tr><td><strong>Start Date:</strong></td><td>{formatDate(job.startdate)}</td></tr>
            <tr><td><strong>Exam Date:</strong></td><td>{job.exam_date || "N/A"}</td></tr>
            <tr><td><strong>Admit Card Date:</strong></td><td>{job.admitcard_dt || "N/A"}</td></tr>
            <tr><td><strong>Exam Result Date:</strong></td><td>{job.examresult_dt || "N/A"}</td></tr>
            <tr><td><strong>Interview Date:</strong></td><td>{job.interview_dt || "N/A"}</td></tr>
          </tbody>
        </table>

        {/* Fee Details */}
        <table className="job-table">
          <thead>
            <tr><th colSpan="2"><strong>Fee Details</strong></th></tr>
          </thead>
          <tbody>
            <tr><td><strong>Total Vacancy:</strong></td><td>{job.total_vacancy || "N/A"}</td></tr>
            <tr><td><strong>Application Fee:</strong></td><td>{job.application_fee || "N/A"}</td></tr>
            <tr><td><strong>Pay Scale:</strong></td><td>{job.pay_scale || "N/A"}</td></tr>
            <tr><td><strong>Age Limit:</strong></td><td>{job.age_limit || "N/A"}</td></tr>
          </tbody>
        </table>

        {/* Additional Info */}
        <table className="job-table">
          <thead>
            <tr><th colSpan="2"><strong>Additional Info</strong></th></tr>
          </thead>
          <tbody>
            <tr><td><strong>Selection Process:</strong></td><td>{job.selection_process || "N/A"}</td></tr>
            <tr>
              <td><strong>Official Website:</strong></td>
              <td>{job.official_website ? <a href={job.official_website} target="_blank" rel="noopener noreferrer">Visit</a> : "N/A"}</td>
            </tr>
            <tr>
              <td><strong>Full Notification:</strong></td>
              <td>{job.full_notification ? <a href={job.full_notification} target="_blank" rel="noopener noreferrer">View Notification</a> : "N/A"}</td>
            </tr>
          </tbody>
        </table>

        {/* Apply Now Button */}
        {job.more_details && (
          <a
            href={job.more_details}
            target="_blank"
            rel="noopener noreferrer"
            className="apply-btn"
          >
            Apply Now
          </a>
        )}
      </div>
    
  );
};

export default JobDetails;

